import { render } from "./DndStatusPopup.vue?vue&type=template&id=5e60a554&scoped=true"
import script from "./DndStatusPopup.vue?vue&type=script&lang=js"
export * from "./DndStatusPopup.vue?vue&type=script&lang=js"

import "./DndStatusPopup.vue?vue&type=style&index=0&id=5e60a554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e60a554"]])

export default __exports__